import api from 'common/api'

import types from './types'

const FT_URL = '/api/features?from=0&pageSize=999'
const dispatchedFetchFeatureToggle = (dispatch) => {
  dispatch({
    type: types.FETCH_FEATURE_TOGGLES_START,
  })
  return api
    .get(FT_URL)
    .then((features) => {
      dispatch({
        type: types.FETCH_FEATURE_TOGGLES_SUCCESS,
        payload: features,
      })
    })
    .catch(() => {
      dispatch({
        type: types.FETCH_FEATURE_TOGGLES_FAILURE,
      })
    })
}
const fetchFeatureToggles = () => {
  return dispatchedFetchFeatureToggle
}

export default {
  fetchFeatureToggles,
}
